/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum WebsocketEvent {
    RECONNECT = 'RECONNECT',
    LEVELUP = 'LEVEL_UP',
    DEVOURPLAYNOTIFICATION = 'DEVOURPLAY_NOTIFICATION',
    REFRESH = 'REFRESH',
    LOGOUT = 'LOGOUT',
    NOTIFICATION = 'NOTIFICATION',
    REWARDDISTRIBUTED = 'REWARD_DISTRIBUTED',
    QUESTPROGRESSED = 'QUEST_PROGRESSED',
    DISCORDMESSAGECREATE = 'DISCORD_MESSAGE_CREATE',
    DISCORDMESSAGEUPDATE = 'DISCORD_MESSAGE_UPDATE',
    DISCORDMESSAGEDELETE = 'DISCORD_MESSAGE_DELETE',
    DISCORDINITIALMESSAGES = 'DISCORD_INITIAL_MESSAGES',
    DISCORDERROR = 'DISCORD_ERROR',
    DISCORDUSERTYPING = 'DISCORD_USER_TYPING',
    DISCORDCHANNELUPDATE = 'DISCORD_CHANNEL_UPDATE',
    QUESTREFRESH = 'QUEST_REFRESH'
}

export function WebsocketEventFromJSON(json: any): WebsocketEvent {
    return WebsocketEventFromJSONTyped(json, false);
}

export function WebsocketEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebsocketEvent {
    return json as WebsocketEvent;
}

export function WebsocketEventToJSON(value?: WebsocketEvent | null): any {
    return value as any;
}

